import { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useSelector, useStore, useDispatch } from 'react-redux'
import {
  Box, Button, Paper, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Typography, IconButton, Tooltip, Chip, Stack,
  TablePagination, TextField, InputAdornment, CircularProgress,
} from '@mui/material'

import Iconify from '../../../Component/common/iconify/Iconify'
import { ICONIFY } from '../../../Constants/iconify'

import AddIcon from '@mui/icons-material/Add'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import SearchIcon from '@mui/icons-material/Search'
import { newGetList, newPut } from '../../../helper/baseFetch_v2'
import { getString } from '../../../helper/util'
import { constants } from '../../../Constants/constants'
import SharedDialog from '../../../Component/common/dialog/SharedDialog'
import { GlobalDialog } from '../../../Component/GlobalDialog'
import { ListFilter } from '../../../Component/ListDisplay/ListFilter'
import { useListParam } from '../../../hooks/useListParam'
import MUITable from '../../../Component/common/table/MUITable'

const resource = 'appVersionTemplatePage'
const DEVICE_TYPES = ['PR', 'KIOSK', 'TV']

export default function AppVersionTemplateList({
    editBtn = true,
    newPath,
    readOnly = false,
    newListFilters,
    onClickListRow,
    dialogFooterBtn
}) {
    const store = useStore()
    const savedAppVersion = useSelector(state => state.appVersion.ui.appVersion)
    const savedAppVersionCommonStatus = useSelector(state => state.appVersion.ui.common)
    const dispatch = useDispatch()

    const [list, setList] = useState([])
    const [listLength, setListLength] = useState(0)
    const [listPagination, setListPagination] = useState({
    sort: 'updateTimestamp',
    order: 'DESC',
    pageSize: 10,
    page: 0,
    filter: {},
    })
    const history = useHistory()
    const lang = useSelector((state) => state.lang.ui.lang)
    const theme = useSelector((state) => state.theme.ui.theme)

    // const [templateList, setTemplateList] = useState([])
    // const [loading, setLoading] = useState(false)
    // const [search, setSearch] = useState('')
    // const [page, setPage] = useState(0)
    // const [rowsPerPage, setRowsPerPage] = useState(10)
    const [deleteDialog, setDeleteDialog] = useState({ open: false, id: null, name: '' })
    const [dialog, setDialog] = useState({ open: false, dialogActions: [] })


  const changeUrlQueryString = newListFilters ? false : true

    const AppVersionListTitleList = [
        {
            key: constants.LIST_DISPLAY_TYPE.STRING,
            value: 'title',
            sort: true,
        },
        {
            key: constants.LIST_DISPLAY_TYPE.STRING,
            value: 'status',
            sort: true,
        },
    ]

  const listFilters = newListFilters ? 
      newListFilters : [
        {
            className: 'filter-input',
            label: { resource: resource, key: 'templateName' },
            clear: true,
            value: '',
            name: 'templateName',
            size: constants.SIZE.SMALL,
        }
    //   {
    //     className: 'filter-input',
    //     label: { resource: resource, key: 'appVersion' },
    //     clear: true,
    //     value: '',
    //     name: 'appVersion',
    //     size: constants.SIZE.SMALL,
    //   },
    //   {
    //     className: 'filter-input',
    //     label: { resource: resource, key: 'buildNumber' },
    //     clear: true,
    //     value: '',
    //     name: 'buildNumber',
    //     size: constants.SIZE.SMALL,
    //   },
    //   {
    //     className: 'filter-input',
    //     label: { resource: resource, key: 'customCode' },
    //     clear: true,
    //     value: '',
    //     name: 'customCode',
    //     size: constants.SIZE.SMALL,
    //   },
    //   {
    //     className: 'filter-input',
    //     label: { resource: resource, key: 'status' },
    //     value: '',
    //     type: constants.TYPE.SELECT,
    //     selectValue: constants.CHOICES.APP_VERSION.STATUS,
    //     name: 'statusList',
    //     size: constants.SIZE.SMALL,
    //   },
    ]
  
    const {
      param,
      setParam,
      onChangeParam,
      onChangeListFilters,
      onChangeListSort,
      onChangeListPage: onChangeListPageParam,
      onChangeListRowsPerPage: onChangeListRowsPerPageParam,
    } = useListParam({
      initialPath: newPath ? newPath : '',
      initialListFilters: _.cloneDeep(listFilters),
      listTitles: AppVersionListTitleList,
      initialSort: 'updateTimestamp',
      initialDirection: 'DESC',
      initialPage: 0,
      initialRowsPerPage: 10,
      changeUrlQueryString,
    })

  const columns = [
      {
        field: 'id',
        headerName: 'Name',
        width: 200,
        flex: 1,
        // renderCell: (params) => {
        //   const target = params.row
        //   return (
        //     <>
        //       <div>
        //         {target.appVersion} 
        //         {/* ({target.buildNumber}) {target.customCode && <Chip label={target.customCode} variant="outlined" size="small" />} */}
        //       </div>
        //       {/* <div style={{ marginTop: 4 }}>
        //         {
        //           target.tagList?.length > 0 && target.tagList.map((tag) => (
        //             <Chip key={tag} label={tag} size="small" sx={{ m: 0.5 }} />
        //           ))
        //         }
        //       </div> */}
        //     </>
        //   )
        // }
      },
      readOnly ? {} : {
        field: 'actions',
        headerName: 'Actions',
        width: 20,
        renderCell: (params) => {
          const mdUrl = params.row.documentList
          return (
            // <Stack direction="row" spacing={1}>
            <div style={{ display: 'flex', flexWrap: 'nowrap' , gap: 8 }}>
              {
                editBtn && (
                  <Tooltip title='edit'>
                    <IconButton onClick={() => onClickEdit(params.row.id)} sx={{ flex: '0 0 auto', p: 0.5 }}>
                      <Iconify icon={ICONIFY.edit} />
                    </IconButton>
                  </Tooltip>
                )
              }
            </div>
            // </Stack>
          )
        }
      },
    ]

    function onChangeListPage(e, newPage) {
        setListPagination((prev) => ({ ...prev, page: newPage }))
        onChangeListPageParam(newPage)
    }

    function onChangeListRowsPerPage(e) {
        const rowsPerPage = e?.target?.value
        setListPagination((prev) => ({ ...prev, pageSize: rowsPerPage }))
        onChangeListRowsPerPageParam(rowsPerPage)
    }


    useEffect(() => {
        fetchList()
    }, [])

    function fetchList() {
        let tempParam = _.cloneDeep(param)
        const filter = {}
        tempParam.listFilters.forEach((filterItem) => {
        if (filterItem.value !== '' && filterItem.value !== undefined) {
            filter[filterItem.name] = filterItem.value
        }
        })

        const newListPagination = {
        // ...listPagination,
        ...filter,
        // status: 'STABLE',
        // filter: JSON.stringify(filter),
        // androidModern: filter.buildTarget === 'ANDROID_MODERN' ? true : undefined,
        // androidLegacy: filter.buildTarget === 'ANDROID_LEGACY' ? true : undefined,
        // androidMpos: filter.buildTarget === 'ANDROID_MPOS' ? true : undefined,
        // ios: filter.buildTarget === 'IOS' ? true : undefined,
        pageSize: tempParam.rowsPerPage,
        page: tempParam.page,
        sortingList: [
            { sort: 'createDateTime', direction: 'DESC' }
        ]
        }
        // setLoading(true)
        newGetList({
            path: 'gulu-console/merchant/shop-app-version-control/template',
            queryObj: newListPagination,
            successCallback: (payload) => {
                setList(payload?.list ?? [])
                setListLength(20)
            },
            failCallback: () => setLoading(false),
            store,
        })
    }

    function onClickCreate() {
        history.push(`/${constants.PATH.APPVERSION_TEMPLATE.APPVERSION_TEMPLATE}/create/0`)
    }

    function onClickEdit(id) {
        history.push(`/${constants.PATH.APPVERSION_TEMPLATE.APPVERSION_TEMPLATE}/edit/` + id + '/0')
    }

    function onClickDelete(id, name) {
        setDeleteDialog({ open: true, id, name })
    }

//   function onConfirmDelete() {
//     newPut({
//       path: `gulu-console/merchant/shop-app-version-template/${deleteDialog.id}`,
//       successCallback: () => {
//         setDeleteDialog({ open: false, id: null, name: '' })
//         setDialog({
//           open: true,
//           dialogContentText: { key: 'deleteSuccess' },
//           dialogActions: [
//             { label: { key: 'backList' }, onClick: () => { setDialog({ open: false, dialogActions: [] }); fetchList() } },
//           ],
//         })
//       },
//       store,
//     })
//   }

//     const filtered = templateList.filter((t) =>
//         t.name?.toLowerCase().includes(search.toLowerCase()) ||
//         t.description?.toLowerCase().includes(search.toLowerCase())
//     )

//   const paginated = filtered.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)

  // summarise which device types are covered
    function getDeviceTypeChips(versionConfigList) {
        if (!versionConfigList?.length) return null
        const covered = [...new Set(versionConfigList.map((i) => i.deviceType))]
        return covered.map((dt) => (
        <Chip key={dt} label={dt} size="small" variant="outlined" color="primary" />
        ))
    }

    return (
        <Box sx={{ p: 3 }}>
        {/* ── Header ── */}
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
            <Typography variant="h5" fontWeight={600}>
            {getString(lang, resource, 'templateList', theme)}
            </Typography>
            <Button variant="contained" startIcon={<AddIcon />} onClick={onClickCreate}>
            {getString(lang, '', 'create', theme)}
            </Button>
        </Stack>

        {/* ── Search ── */}
        {/* <TextField
            size="small"
            placeholder="Search by name or description..."
            value={search}
            onChange={(e) => { setSearch(e.target.value); setPage(0) }}
            sx={{ mb: 2, width: 320 }}
            InputProps={{
            startAdornment: (
                <InputAdornment position="start">
                <SearchIcon fontSize="small" />
                </InputAdornment>
            ),
            }}
        /> */}

        {/* ── Table ── */}
        {/* <TableContainer component={Paper} variant="outlined">
            <Table size="small">
            <TableHead>
                <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Device Types</TableCell>
                <TableCell>Config Count</TableCell>
                <TableCell>Created Date</TableCell>
                <TableCell align="right">Actions</TableCell>
                </TableRow>
            </TableHead>

            <TableBody>
                {loading ? (
                <TableRow>
                    <TableCell colSpan={6} align="center" sx={{ py: 4 }}>
                    <CircularProgress size={24} />
                    </TableCell>
                </TableRow>
                ) : paginated.length === 0 ? (
                <TableRow>
                    <TableCell colSpan={6} align="center" sx={{ py: 4 }}>
                    <Typography variant="body2" color="textSecondary">No templates found</Typography>
                    </TableCell>
                </TableRow>
                ) : (
                paginated.map((row) => (
                    <TableRow key={row.id} hover>
                    <TableCell>
                        <Typography variant="body2" fontWeight={600}>{row.name}</Typography>
                    </TableCell>
                    <TableCell>
                        <Typography variant="body2" color="textSecondary" noWrap sx={{ maxWidth: 200 }}>
                        {row.description || '-'}
                        </Typography>
                    </TableCell>
                    <TableCell>
                        <Stack direction="row" spacing={0.5} flexWrap="wrap">
                        {getDeviceTypeChips(row.versionConfigList)}
                        </Stack>
                    </TableCell>
                    <TableCell>{row.versionConfigList?.length ?? 0}</TableCell>
                    <TableCell>
                        {row.createdDate ? new Date(row.createdDate).toLocaleDateString() : '-'}
                    </TableCell>
                    <TableCell align="right">
                        <Tooltip title="Edit">
                        <IconButton size="small" color="primary" onClick={() => onClickEdit(row.id)}>
                            <EditIcon fontSize="small" />
                        </IconButton>
                        </Tooltip>
                        <Tooltip title="Delete">
                        <IconButton size="small" color="error" onClick={() => onClickDelete(row.id, row.name)}>
                            <DeleteIcon fontSize="small" />
                        </IconButton>
                        </Tooltip>
                    </TableCell>
                    </TableRow>
                ))
                )}
            </TableBody>
            </Table>
        </TableContainer>

        <TablePagination
            component="div"
            count={filtered.length}
            page={page}
            rowsPerPage={rowsPerPage}
            onPageChange={(_, p) => setPage(p)}
            onRowsPerPageChange={(e) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0) }}
            rowsPerPageOptions={[5, 10, 25]}
        /> */}

            <Box sx={{ p: 3 }}>
                {/* {!onClickListRow && ( */}
                {/* <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div className="title">
                    App Version
                    </div>
                    {
                    isDeveloper && (
                        <Button startIcon={<Add />} variant='contained' onClick={onClickCreate}>
                        Create
                        </Button>
                    )
                    }
                </Box> */}
                {/* )} */}

                <ListFilter onChangeListFilters={onChangeListFilters} listFilters={param.listFilters} />

                <Box sx={{ flex: 1, overflow: 'auto' }}>
                <MUITable
                    stickyHeader
                    columns={columns}
                    rows={list}
                    pagination={listPagination}
                    setPagination={setListPagination}
                    listLength={listLength}
                    onClickListRow={onClickListRow}
                    handleChangePage={onChangeListPage}
                    handleChangeRowsPerPage={onChangeListRowsPerPage}
                    stickyEditBtn
                    // selected={selected}
                    // setSelected={setSelected}
                />
                {dialogFooterBtn}
                </Box>
            </Box>

        {/* ── Delete Confirm Dialog ── */}
        <SharedDialog
            open={deleteDialog.open}
            onClose={() => setDeleteDialog({ open: false, id: null, name: '' })}
            title="Confirm Delete"
            content={
            <Typography>
                Are you sure you want to delete template{' '}
                <Typography component="span" fontWeight={600}>{deleteDialog.name}</Typography>?
                This action cannot be undone.
            </Typography>
            }
            actions={
            <Stack direction="row" gap={1}>
                {/* <Button variant="contained" color="error" onClick={onConfirmDelete}>Delete</Button> */}
                <Button variant="outlined" onClick={() => setDeleteDialog({ open: false, id: null, name: '' })}>Cancel</Button>
            </Stack>
            }
        />

        {dialog?.open && <GlobalDialog dialogInfo={dialog} />}
        </Box>
    )
}